import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "data-item" };
const _hoisted_2 = { class: "data-item__header" };
const _hoisted_3 = { class: "data-item__title" };
const _hoisted_4 = { class: "data-item__actions" };
const _hoisted_5 = { class: "data-item__content" };
const _hoisted_6 = {
    key: 0,
    class: "data-item__section"
};
import { onMounted, ref, watch } from 'vue';
import importProfileRepository from "../services/ShopImportProfileRepository";
import env from '../services/AppEnv';
import trans from '@astina/paloma-common-ui/src/services/Translator';
import AppForm from "@astina/paloma-common-ui/src/components/form/AppForm.vue";
import { saveShopImportProfile } from "../commands/SaveShopImportProfile";
import { useRouter } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImportProfileCreateView',
    setup(__props) {
        const router = useRouter();
        const draft = createDraft();
        const form = ref(null);
        const templates = ref([]);
        const validation = ref({ errors: [], fields: {} });
        const loading = ref(false);
        onMounted(() => {
            loadTemplates()
                .then(initForm);
        });
        function onSubmit() {
            loading.value = true;
            saveShopImportProfile(draft)
                .then(profile => {
                router.push({ name: 'integration_import_details', params: { id: profile.id } });
            })
                .catch((v) => {
                validation.value = v;
            })
                .finally(() => loading.value = false);
        }
        function onCancel() {
            router.push({ name: 'integration_import' });
        }
        watch(() => draft.template, onDraftReaderChange);
        function onDraftReaderChange() {
            draft.templateSettings = {};
            if (!draft.name) {
                const template = templates.value.find(t => t.info.name === draft.template);
                draft.name = (template && template.info.label) || '';
            }
            initForm();
        }
        function initForm() {
            form.value = createFormConfig();
        }
        function loadTemplates() {
            return importProfileRepository.listTemplates()
                .then(t => templates.value = t);
        }
        function createFormConfig() {
            const fields = [
                {
                    name: 'template',
                    label: trans('import_profile.template'),
                    type: 'choice',
                    options: {
                        required: true,
                        choices: templates.value.map(template => {
                            return { value: template.info.name, label: template.info.label };
                        }),
                    },
                },
                {
                    name: 'name',
                    label: trans('import_profile.name'),
                    type: 'text',
                    options: {
                        required: true,
                        maxLength: 255,
                    },
                },
            ];
            if (draft && draft.template) {
                const template = templates.value.find(t => t.info.name === draft.template);
                if (template && template.info.form.fields.length > 0) {
                    fields.push({
                        name: 'templateSettings',
                        label: trans('import_profile.template_settings'),
                        type: 'form',
                        fields: template.info.form.fields,
                        options: {},
                    });
                }
            }
            return {
                name: 'import_profile',
                fields: fields,
            };
        }
        function createDraft() {
            return {
                id: null,
                locale: env.locale,
                name: '',
                status: 'inactive',
                template: null,
                templateSettings: null,
            };
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('import_profile.create')), 1),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_router_link, {
                            to: { name: 'integration_import' },
                            class: "button button--outline"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("div", _hoisted_5, [
                    (form.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(AppForm, {
                                form: form.value,
                                data: _unref(draft),
                                validation: validation.value,
                                loading: loading.value,
                                onSubmit: onSubmit,
                                "submit-icon": "save",
                                onCancel: onCancel
                            }, null, 8, ["form", "data", "validation", "loading"])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
